var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._b({staticClass:"tw-inline-block tw-no-underline tw-text-inherit",class:{'tw-transition-colors tw-duration-200 tw-ease-in-out': _vm.type === 'text'}},'router-link',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }